import { useQuery } from '@tanstack/react-query';

import { HEM_COMMERCE_BASE_PATH } from '../constants';

export type Data = {
  ip: string;
  city: string;
  country: string;
  continent: string;
  longitude: string;
  latitude: string;
  region: string;
  'region-code': string;
  'metro-code': null | string;
  'postal-code': string;
  timezone: string;
};

export type Status = 'pending' | 'error' | 'success';

export const useIPLocation = (): {
  status: Status;
  error: null | unknown;
  data: Data;
} => {
  const { status, error, data } = useQuery({
    queryKey: ['use-ip-location'],
    queryFn: async () => {
      try {
        const resp = await fetch(`${HEM_COMMERCE_BASE_PATH}/ip/`);
        if (!resp.ok) {
          throw Error(resp.statusText);
        }
        const json = await resp.json();
        return json;
      } catch (err) {
        console.log(err);
      }
    },
    staleTime: Infinity,
  });

  return { status, error, data };
};
